import { render, staticRenderFns } from "./QCarrierProductsTable.vue?vue&type=template&id=22caa5ae&"
import script from "./QCarrierProductsTable.vue?vue&type=script&lang=js&"
export * from "./QCarrierProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./QCarrierProductsTable.vue?vue&type=style&index=0&id=22caa5ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports